import types from 'actions/types'
import {createPivotTableReducer} from 'reducers/pivotTable'
import {combineReducers} from 'redux'
import {getPivotTableTotalPriceReducer} from "helpers/pivotTable"

const showAllRevisions = (state = false, action) => {
  switch (action.type) {
    case types.QUOTING_VIEW_QUOTES_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('showAllRevisions')) ? action.filters.showAllRevisions : state
    default:
      return state
  }
}

const addedQuote = (state = null, action) => {
  switch (action.type) {
    default:
      return state
  }
}

const timeKey = (state = 'days:-30', action) => {
  switch (action.type) {
    case types.QUOTING_VIEW_QUOTES_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('timeKey')) ? action.filters.timeKey : state
    default:
      return state
  }
}

const dateType = (state = 'modified', action) => {
  switch (action.type) {
    case types.QUOTING_VIEW_QUOTES_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('dateType')) ? action.filters.dateType : state
    default:
      return state
  }
}

const personId = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_VIEW_QUOTES_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('personId')) ? action.filters.personId : state
    default:
      return state
  }
}

const personCreator = (state = false, action) => {
  switch (action.type) {
    case types.QUOTING_VIEW_QUOTES_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('personCreator')) ? action.filters.personCreator : state
    default:
      return state
  }
}

const personEstimator = (state = false, action) => {
  switch (action.type) {
    case types.QUOTING_VIEW_QUOTES_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('personEstimator')) ? action.filters.personEstimator : state
    default:
      return state
  }
}

const personSalesman = (state = true, action) => {
  switch (action.type) {
    case types.QUOTING_VIEW_QUOTES_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('personSalesman')) ? action.filters.personSalesman : state
    default:
      return state
  }
}

const companyId = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_VIEW_QUOTES_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('companyId')) ? action.filters.companyId : state
    case types.CONTACTS_RECENTS_REMOVE:
      return state && state === action.companyId ? null : state
    case types.CONTACTS_RECENTS_CLEAR:
      return null  // not necessarily correct, but best guess
    default:
      return state
  }
}

const type = (state = [-1], action) => {

  switch (action.type) {
    case types.QUOTING_VIEW_QUOTES_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('type')) ? action.filters.type : state
    default:
      return state
  }
}

const orderTypeId = (state = true, action) => {
  switch (action.type) {
    case types.QUOTING_VIEW_QUOTES_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('orderTypeId')) ? action.filters.orderTypeId : state
    default:
      return state
  }
}

export const quotingContextQuotePivotTableKey = 'quotingContext.quotes.pivotTable'

const total = (state = null, action) => {
  return getPivotTableTotalPriceReducer(state, action, quotingContextQuotePivotTableKey)
}

export default combineReducers({
  pivotTable: createPivotTableReducer({key: quotingContextQuotePivotTableKey, defaultSortColumn: 'desc'}),
  showAllRevisions,
  addedQuote,
  timeKey,
  dateType,
  personId,
  personCreator,
  personEstimator,
  personSalesman,
  companyId,
  type,
  total,
  orderTypeId,
})
